import assign from './assign';
import omit from './omit';

export default {
  assign,
  omit,
};



// WEBPACK FOOTER //
// ./src/actions/object/index.js